import _ from 'lodash';
import {
  teacherAssignmentReport,
  getStudentAssignmentReport,
} from "common/api";
import { formatDate } from "../../../shared/helpers/formatDate";
import { studentsCountByStatus } from "./helpers/studentsCountByStatus";
import Vue from "vue";

const state = {
  recurringActivities: {},
  passages: [],
  specificActivities: [],
  studentsList: {},
  allStudentsList: [],
  competitionActivities: [],
  liderboard: {},
  studentsReport: {},
  historyActivities: [],
  activityIdList: {},
  isLoading: true,
};

const getters = {

  getIsReportLoading: (state) => (assignmentId) =>
   state.studentsReport[assignmentId] === undefined ? false : state.studentsReport[assignmentId].isLoading,
  getStudentAssimentsByActivityId: (state) => (activityId) => {
    return state.studentAssiments[activityId];
  },
  getliderboardByActivityId: (state) => (activityId) => {
    return state.liderboard[activityId];
  },
  getStudentInfoById: (state) => (studentId) => {
    let student = state.studentsList ? state.studentsList[studentId] : {};
    if (_.isEmpty(student) && state.allStudentsList) {
      student = state.allStudentsList.find(studentInfo => studentInfo.id === studentId) || {};
      addBackwardsCompatibilityFields(student);
    }
    return student;
  },
  getStudentReportDataByAssignmentId: (state) => (assignmentId) => {
    return state.studentsReport[assignmentId];
  },
  getRecurringActivitiesSorted: (state) => () => {
    const obj = state.recurringActivities;
    const sortedKeys = Object.keys(obj)
      .map(Number)
      .sort((a, b) => b - a);
    const sortedArr = [];
    sortedKeys.forEach((key) => {
      sortedArr.push(obj[key]);
    });
    return sortedArr;
  },
};

const mutations = {

  SET_ACTIVITY_ID_LIST(state, payload) {
    Vue.set(state.activityIdList, payload.id, payload.name);
  },

  SET_IS_LOADING(state, payload) {
    state.isLoading = payload;
  },

  SET_RECURRING_ACTIVITIES(state, payload) {
    const { assignmentItems, assignmentDetails, upcomingStartDate, upcomingDueDate, activityFilterId } = payload;
    const prepearedItems = assignmentItems
      .map((item) => {
        return {
          ...item,
          studentCount: studentsCountByStatus(item.studentAssignments),
        };
      })
      .sort((a, b) => b.id - a.id);

    const result = {
      assignmentDetails,
      assignmentItems: prepearedItems,
      upcomingDueDate,
      upcomingStartDate,
    };
    //  console.log({activityFilterId, res: result.id});
    if (!activityFilterId || +activityFilterId === result.assignmentDetails.id) {
      Vue.set(state.recurringActivities, assignmentDetails.id, result);
    }
  },

  SET_PASSAGES(state, payload) {
    const { assignmentItems, assignmentDetails } = payload;
    const passages = assignmentItems.map((item) => {
      return {
        ...item,
        studentCount: studentsCountByStatus(item.studentAssignments),
      };
    });
    state.passages.unshift({ assignmentDetails, assignmentItems: passages });
  },

  SET_COMPETITION_ACTIVITIES(state, payload) {
    const { assignmentItems, assignmentDetails } = payload;
    const competitionActivities = assignmentItems.map((item) => {
      return {
        ...item,
        participants: item.studentAssignments.length,
      };
    });
    state.competitionActivities.unshift({ assignmentDetails, assignmentItems: competitionActivities });
  },

  SET_LIDERBOARD(state, payload) {
    const { studentAssignments, activityId } = payload;
    const students = state.studentsList;
    const allStudents = state.allStudentsList;

    const leaderboard = studentAssignments.map((item) => {
      const studentUserInfo = getStudentUserInfo(students, allStudents, item.studentId);
      return {
        ...studentUserInfo,
        kPoints: item.collectedXp,
        countQuizes: item.studentQuizResponseIds ? item.studentQuizResponseIds.split(",").length: 0,
        rank: item.assignmentRating,
      };
    });

    state.liderboard[activityId] = leaderboard;
  },

  SET_STUDENT_LIST(state, payload) {
    payload.forEach((item) => {
      item.students_list.forEach((student) => {
        state.studentsList[student.studentId] = Object.assign({}, state.studentsList[student.studentId], {
          firstName: student.firstName,
          lastName: student.lastName,
          nickName: student.username,
          // [item.classId]: {
          classInfo: {
            classId: item.classId,
            classIconSrc: item.avatar,
            className: item.name,
          },
        });
      });
    });
  },

  SET_ALL_STUDENTS_LIST(state, payload) {
    state.allStudentsList = payload;
  },

  SET_STUDENT_REPORT(state, payload) {
    const { assimentId, reportData } = payload;
    Vue.set(state.studentsReport, assimentId, reportData);
  },
  SET_HISTORY_ACTIVITIES(state, payload) {
    const result = {};
    const students = state.studentsList;
    const allStudents = state.allStudentsList;

    payload.forEach((item) => {
      if (!result[item.assignmentDetails.type]) result[item.assignmentDetails.type] = [];
      const assignmentItems = [];
      item.assignmentItems.forEach((assignment) => {
        if (item.assignmentDetails.type !== "LOCAL_COMPETITION") {
          assignmentItems.unshift({
            ...assignment,
            studentCount: studentsCountByStatus(assignment.studentAssignments),
          });
        } else {
          if (assignment.status !== "DELETED") {
            const leaderboard = assignment.studentAssignments.map((index) => {
              const studentUserInfo = getStudentUserInfo(students, allStudents, index.studentId);
              return {
                ...studentUserInfo,
                kPoints: index.collectedXp,
                countQuizes: index.studentQuizResponseIds?.split(",").length || 0,
                rank: index.assignmentRating,
              };
            });
            state.liderboard[assignment.id] = leaderboard;
          }
          assignmentItems.unshift({
            ...assignment,
            participants: assignment.studentAssignments.length,
          });
        }
      });
      if (!state.activityIdList[item.assignmentDetails.id])
      result[item.assignmentDetails.type].unshift({ ...item, assignmentItems });
    });
    state.historyActivities = result;
  },
};

const actions = {
  async getAssiments({ commit }, payload) {
    const { date, classes, allStudents, activityType, activityFilterId } = payload;
    commit("SET_IS_LOADING", true);
    commit("SET_STUDENT_LIST", classes);
    commit("SET_ALL_STUDENTS_LIST", allStudents);
    try {
      const callMutation = {
        FIXED_WEEKLY: (data) => commit("SET_RECURRING_ACTIVITIES", data),
        PASSAGE: (data) => commit("SET_PASSAGES", data),
        LOCAL_COMPETITION: (data) => {
          commit("SET_COMPETITION_ACTIVITIES", data);
          commit("SET_LIDERBOARD", {
            studentAssignments: data.assignmentItems[0].studentAssignments,
            activityId: data.assignmentItems[0].id,
          });
        },
      };

      const response = await teacherAssignmentReport(date.startDate, date.endDate);
      // console.log(response);
      if (response.data && response.data.length !== 0) {
        response.data.forEach((item) => {
          // console.log(item.assignmentDetails.type);
          if (activityType === item.assignmentDetails.type || activityType === "ALL") {
            commit("SET_ACTIVITY_ID_LIST", item.assignmentDetails);
            callMutation[item.assignmentDetails.type]({ ...item, activityFilterId });
          }
        });
      }
      commit("SET_IS_LOADING", false);
    } catch (error) {
      console.log(error);
    }
  },

  async getStudentReportByAssigmentId({ commit }, payload) {
    const { assignmentId } = payload;
    commit("SET_STUDENT_REPORT", {
      assimentId: assignmentId,
      reportData: {
        isLoading: true,
      },
    });
    try {
      const response = await getStudentAssignmentReport(assignmentId);
      // console.log(assignmentId, response.data);
      const {quizResponses} = response.data;
      if (quizResponses[0] !== null) {
        const result = quizResponses.map((item) => {
          return {
            isLoading: false,
            testName: item.readingComprehensionQuiz.title,
            dateTaken: formatDate(item.completeDate),
            percentage: `${item.percentageCorrect.toFixed(0)}%`,
            gradeLevel: item.readingComprehensionQuiz.level,
            lexileLevel: `${item.readingComprehensionQuiz.lexileLevel}L`,
          };
        });
      commit("SET_STUDENT_REPORT", {
        assimentId: assignmentId,
        reportData: result,
      });
     }
    } catch (error) {
      console.log(error);
    }
  },

  async getHistoryActivities({ commit }, payload) {
    const { date } = payload;
    commit("SET_IS_LOADING", true);
    try {
      const response = await teacherAssignmentReport(date.startDate, date.endDate);
      commit("SET_HISTORY_ACTIVITIES", response.data);
      commit("SET_IS_LOADING", false);
    } catch (error) {
      console.log(error);
    }
  },
};

const getStudentUserInfo = (classStudents, allStudents, studentId) => {
  let student = classStudents ? classStudents[studentId] : {};
  if (_.isEmpty(student) && allStudents) {
    student = allStudents.find(studentInfo => studentInfo.id === studentId) || {}
    addBackwardsCompatibilityFields(student);
  }
  return {
    className: student.classInfo?.className || '-',
    firstName: student.firstName,
    lastName: student.lastName,
    nickName: student.nickName,
  }
}

const addBackwardsCompatibilityFields = (student) => {
  student.firstName = student.first_name;
  student.lastName =student.last_name;
  student.nickName =student.username;
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
